module.exports = __webpack_public_path__ + "img/offlinepay.4950992b.png";